<template>
  <div style="  background-color: inherit;">
    <div
      :style="style"
      v-if="!expandToRight"
      :class="{
        'for-top-search-for-non-sc': sector !== 'call_again',
        'top-multi-select-bar-closedV':
          !expandToRight && sector === 'call_again',
        'top-multi-select-bar':
          expandToRight && sector !== 'sms' && sector !== 'bad_number',
        'top-multi-select-bar-countries':
          sector === 'countries' && !expandToRight,
        'top-multi-select-bar-assignments': selectedTab === 'assignments',
        'top-multi-select-bar-rank':
          sector === 'assignments' &&
          (selectedTab === 'rank_1' ||
            selectedTab === 'rank_2' ||
            selectedTab === 'rank_3' ||
            selectedTab === 'assigned_rankings')
      }"
    >
      <div v-if="false" class="sort-buttons">
        <button
          v-if="selectedMainTab === 'clients'"
          class="btn btn-default btn-sm override"
          @click="emitShowExpansion"
        >
          <span
            :class="{
              'fas fa-arrow-circle-right': expand,
              'fas fa-arrow-circle-left': !expand
            }"
            class="fa"
          ></span>
        </button>
        <button
          class="btn btn-default btn-sm override"
          @click="emitApplyAmountSorting"
        >
          <span
            :class="{
              'fas fa-sort-amount-down': sortOrderAmount === 'asc',
              'fas fa-sort-amount-up': sortOrderAmount === 'desc'
            }"
            class="fa"
          ></span>
        </button>
        <button
          class="btn btn-default btn-sm override"
          @click="emitApplyAlphaSorting"
        >
          <span
            :class="{
              'fas fa-sort-alpha-down': sortOrderAlpha === 'asc',
              'fas fa-sort-alpha-up': sortOrderAlpha === 'desc'
            }"
            class="fa"
          ></span>
        </button>
      </div>

      <input
        v-if="!extSearch"
        v-model="internalSearchQuery"
        class="input-main"
        :class="{ 'input-main-non-sc': sector === 'call_again' }"
        placeholder="Search filter"
        style="max-width: 80px; border-radius: 10px"
        type="search"
      />
      <div v-if="sector !== 'call_again'" class="top-check-div">
        <label
          class="multi-check-label"
          :class="{
            'multi-check-label-questions': sector === 'questions',
            'multi-check-label-questions-status': sector === 'questions_status',
            'multi-check-label-advertising': sector === 'advertising',
            'multi-check-label-keyword': sector === 'keyword',
            'multi-check-label-device': sector === 'device',
            'multi-check-label-location': sector === 'location',
            'multi-check-label-placement': sector === 'placement'
          }"
          for="exclude"
        >
          <input
            id="exclude"
            v-model="exclude"
            class="multi-check"
            type="checkbox"
          />
          Ex</label
        >
      </div>
    </div>
    <div v-if="sector === 'call_again'" class="for-three-opt-toggle">
      <form action="" id="searchTypeToggle">
        <div></div>
        <label class="selected" v-tooltip.top="{ content: 'ALL' }">
          <input
            type="radio"
            name="searchtype"
            data-location="0"
            value=""
            v-model="conditionForFilteringMsAll"
          />
          <div class="font-and-wight">A</div>
        </label>

        <label v-tooltip.top="{ content: 'WITH AUTO' }">
          <input
            type="radio"
            name="searchtype"
            data-location="calc(100% - 8px)"
            value="1"
            v-model="conditionForFilteringMsAll"
          />
          <div class="font-and-wight">W</div>
        </label>
        <label v-tooltip.top="{ content: 'WITHOUT AUTO' }">
          <input
            type="radio"
            name="searchtype"
            data-location="calc(200% - 12px)"
            value="2"
            v-model="conditionForFilteringMsAll"
          />
          <div class="font-and-wight">EX</div>
        </label>
      </form>
    </div>
    <div
      v-if="expandToRight"
      :class="{
        'top-multi-select-bar':
          expandToRight &&
          selectedTab !== 'assignments' &&
          sector !== 'bad_number' &&
          sector != 'not_interested',
        'top-multi-select-bar-bad-number': sector === 'bad_number',
        'top-multi-select-bar-sms': expandToRight && sector === 'sms',
        'top-multi-select-bar-rank':
          sector === 'assignments' &&
          (selectedTab === 'rank_1' ||
            selectedTab === 'rank_2' ||
            selectedTab === 'rank_3' ||
            selectedTab === 'assigned_rankings'),
        'top-multi-select-bar-assignments': sector === 'assignments',
        'top-multi-select-bar-ni': sector === 'not_interested'
      }"
    >
      <input
        v-if="!extSearch"
        v-model="internalSearchQuery"
        class="input-main"
        :class="{ 'input-main-non-sc': sector === 'call_again' }"
        placeholder="Search filter"
        style="max-width: 80px; border-radius: 10px;"
        type="search"
      />
      <div class="top-check-div">
        <label
          :class="{
            'multi-check-label-assign': sector === 'assignments',
            'multi-check-label-sms': sector === 'sms',
            'multi-check-label-questions-status': sector === 'questions_status',
            'multi-check-label-keyword': sector === 'keyword'
          }"
          class="multi-check-label"
          for="exclude_1"
        >
          <input
            id="exclude_1"
            v-model="exclude"
            v-on:click="$emit('excludeValueChanged',exclude)"
            class="multi-check "
            type="checkbox"
          />
          Ex</label
        >
          <!--            log('from top multi',exclude);-->
      </div>
      <div v-if="false" class="sort-buttons">
        <button
          class="btn btn-default btn-sm override"
          @click="emitApplyAmountSorting"
        >
          <span
            :class="{
              'fas fa-sort-amount-down': sortOrderAmount === 'asc',
              'fas fa-sort-amount-up': sortOrderAmount === 'desc'
            }"
            class="fa"
          ></span>
        </button>
        <button
          class="btn btn-default btn-sm override"
          @click="emitApplyAlphaSorting"
        >
          <span
            :class="{
              'fas fa-sort-alpha-down': sortOrderAlpha === 'asc',
              'fas fa-sort-alpha-up': sortOrderAlpha === 'desc'
            }"
            class="fa"
          ></span>
        </button>
        <button
          v-if="
            selectedMainTab !== 'bn' &&
              selectedMainTab !== 'ni' &&
              selectedMainTab !== 'ended' &&
              selectedMainTab !== 'merged'
          "
          class="btn btn-default btn-sm override"
          @click="emitShowExpansion"
        >
          <span
            :class="{
              'fas fa-arrow-circle-left': expand,
              'fas fa-arrow-circle-right': !expand
            }"
            class="fa"
          ></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopMultiSelectBar",
  props: {
    style: {
      type: String
    },
    selectedMainTab: {
      type: String
    },
    expandToRight: {
      type: Boolean,
      default: false
    },
    queryObject: {
      type: Object
    },
    expand: {
      type: Boolean
    },
    query: {
      type: String
    },
    extSearch: {
      type: Boolean
    },
    sector: {
      type: String
    },
    open: {
      type: Boolean
    },
    statsOptions: {
      type: Array,
      default: () => []
    },
    pageNum: {
      type: Number,
      default: 0
    },
    selectedTab: {
      type: String
    },
    showExtMultiSelect: {
      type: Boolean
    }
  },

  data() {
    return {
      internalSearchQuery: "",
      searchResults: [],
      showResults: false,
      exclude: false,
      checkAll: false,
      sortOrderAmount: "asc",
      sortOrderAlpha: "asc",
      conditionForFilteringMsAll: null
    };
  },
  mounted() {
    $("form input").click(function(event) {
      $("form > div").css(
        "transform",
        "translateX(" + $(this).data("location") + ")"
      );
      $(this)
        .parent()
        .siblings()
        .removeClass("selected");
      $(this)
        .parent()
        .addClass("selected");
    });
  },
  created() {
    $("form input").click(function(event) {
      $("form > div").css(
        "transform",
        "translateX(" + $(this).data("location") + ")"
      );
      $(this)
        .parent()
        .siblings()
        .removeClass("selected");
      $(this)
        .parent()
        .addClass("selected");
    });
  },
  methods: {
    log(str){
      // console.log(str)
    },
    emitShowExpansion() {
      let calendarsArray = [
        "last_modified_na_from",
        "last_modified_na_to",
        "last_modified_lead_from",
        "last_modified_lead_to",
        "registered_on_from",
        "registered_on_to",
        "deposit_at_from",
        "deposit_at_to",
        "assigned_at_from",
        "assigned_at_to",
        "last_modified_from",
        "last_modified_to",
        "last_modified_personal_from",
        "last_modified_personal_to",
        "last_transfer_from",
        "last_transfer_to",
        "scheduled_call_to_from",
        "scheduled_call_to_to",
        "last_referral_from",
        "last_referral_to",
        "support_at_from",
        "support_at_to",
        "group_assigned_at_from",
        "group_assigned_at_to",
        "online"
      ];

      let yesOrNo = false;

      calendarsArray.forEach(item => {
        if (!this.expand) {
          if (this.queryObject.hasOwnProperty(item) && yesOrNo === false) {
            this.$emit("show_expansion");
            yesOrNo = true;
          } else if (yesOrNo === false) {
            return this.$store.commit("main/setShowVikiMsg", {
              show: true,
              msg: "Please choose a\n       calendar",
              type: "ERROR",
              op: { type: "" },
              op_code: null,
              updatedAt: null
            });
          }
        } else if (this.expand) {
          this.$emit("show_expansion");
        }
      });
    },
    emitApplyAmountSorting() {
      let order = this.sortOrderAmount;
      if (order === "asc") {
        this.sortOrderAmount = "desc";
      }

      if (order === "desc") {
        this.sortOrderAmount = "asc";
      }
      this.$emit("applyAmountSorting", this.sortOrderAmount);
    },
    emitApplyAlphaSorting() {
      let order = this.sortOrderAlpha;
      if (order === "asc") {
        this.sortOrderAlpha = "desc";
      }
      if (order === "desc") {
        this.sortOrderAlpha = "asc";
      }
      this.$emit("applyAlphaSorting", this.sortOrderAlpha);
    },

    searchFilter(q) {
      function escapeRegExp(s) {
        return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      }

      const words = q
        .split(/\s+/g)
        .map(s => s.trim())
        .filter(s => !!s);
      const hasTrailingSpace = q.endsWith(" ");
      const searchRegex = new RegExp(
        words
          .map((word, i) => {
            if (i + 1 === words.length && !hasTrailingSpace) {
              // The last word - ok with the word being "startswith"-like
              return `(?=.*\\b${escapeRegExp(word)})`;
            } else {
              // Not the last word - expect the whole word exactly
              return `(?=.*\\b${escapeRegExp(word)}\\b)`;
            }
          })
          .join("") + ".+",
        "gi"
      );
      return this.statsOptions.filter(item => {
        return searchRegex.test(item.title);
      });
    }
  },

  watch: {
    exclude(){
      this.$emit('excludeValueChanged',this.exclude)
    },
    open() {
      if (this.open) {
        let calendarsArray = [
          "last_modified_na_from",
          "last_modified_na_to",
          "last_modified_lead_from",
          "last_modified_lead_to",
          "registered_on_from",
          "registered_on_to",
          "deposit_at_from",
          "deposit_at_to",
          "assigned_at_from",
          "assigned_at_to",
          "last_modified_from",
          "last_modified_to",
          "last_modified_personal_from",
          "last_modified_personal_to",
          "last_transfer_from",
          "last_transfer_to",
          "scheduled_call_to_from",
          "scheduled_call_to_to",
          "last_referral_from",
          "last_referral_to",
          "support_at_from",
          "support_at_to",
          "group_assigned_at_from",
          "group_assigned_at_to",
          "online"
        ];
        let yesOrNo = false;
        calendarsArray.forEach(item => {
          if (this.expand === false && this.selectedMainTab === "clients") {
            if (this.queryObject.hasOwnProperty(item) && yesOrNo === false) {
              this.$emit("show_expansion");
              yesOrNo = true;
            }
          }
        });
      }
    },
    // queryObject(){
    //   if(this.open){
    //     let calendarsArray = [
    //       'registered_on_from',
    //       'registered_on_to',
    //       'deposit_at_from',
    //       'deposit_at_to',
    //       'assigned_at_from',
    //       'assigned_at_to',
    //       'last_modified_from',
    //       'last_modified_to',
    //       'last_modified_personal_from',
    //       'last_modified_personal_to',
    //       'last_transfer_from',
    //       'last_transfer_to',
    //       'scheduled_call_to_from',
    //       'scheduled_call_to_to',
    //       'last_referral_from',
    //       'last_referral_to',
    //       'support_at_from',
    //       'support_at_to',
    //       'group_assigned_at_from',
    //       'group_assigned_at_to',
    //       'online'
    //     ];
    //     let yesOrNo = false;
    //     calendarsArray.forEach(item => {
    //       if (this.expand === false && this.selectedMainTab === 'clients') {
    //         if (this.queryObject.hasOwnProperty(item) && yesOrNo === false) {
    //           this.$emit('show_expansion')
    //           yesOrNo = true
    //         }
    //       }
    //     })
    //   }
    // },
    statsOptions() {
      if (this.open) {
        if (
          this.statsOptions.length > 0 &&
          this.sector === "assignments" &&
          this.selectedTab === "assignments"
        ) {
          this.emitApplyAmountSorting();
        }
      }
    },
    // exclude() {
    //   this.$emit("exclude", this.exclude);
    // },
    conditionForFilteringMsAll() {
      this.$emit("conditionForFilteringMs", this.conditionForFilteringMsAll);
    },

    checkAll() {
      this.$emit("check_all", this.checkAll);
    },
    query() {
      this.internalSearchQuery = this.query;
    },
    internalSearchQuery() {
      if (this.internalSearchQuery.length === 0) {
        this.searchResults = [];
      } else {
        this.searchResults = this.searchFilter(this.internalSearchQuery);
      }
      this.$emit("searchParams", this.internalSearchQuery);

      if (this.searchResults.length > 0) {
        this.showResults = true;
        this.$emit("searching", this.searchResults);
      }

      if (this.searchResults.length === 0) {
        this.showResults = false;
        this.$emit("searching", this.searchResults);
      }

      if (this.internalSearchQuery.length === 0) {
        this.showResults = false;
      }
    }
  }
};
</script>

<style scoped>

.top-check-div{
  z-index: 2 !important;
}
.top-check-div > label{
  z-index: 2 !important;
}

.input-main {
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border: 1px solid #d7d7d7;
  height: 30px;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 13px;
  text-transform: uppercase;
  box-sizing: border-box;
  margin-bottom: 5px;
  right: -44px;
}
.input-main-non-sc {
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border: 1px solid #d7d7d7;
  height: 30px;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 13px;
  text-transform: uppercase;
  box-sizing: border-box;
  margin-bottom: 5px;
  left: 38px;
}

.top-multi-select-bar {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  position: absolute;
  padding-top: 8px;
  padding-right: 10px;
  padding-left: 10px;
  border-radius: 5px;
  min-width: 93px;
  background: inherit !important;
}
.top-multi-select-bar-rank {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  position: absolute;
  padding-top: 8px;
  padding-right: 10px;
  padding-left: 10px;
  border-radius: 5px;
  min-width: 93px;
  background: inherit !important;
}
.top-multi-select-bar-bad-number {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  position: absolute;
  padding-top: 8px;
  padding-right: 10px;
  padding-left: 10px;
  left: 0;
  top: -33px;
  border-radius: 5px;
  /* background-color: #ae3ede; */
  background-color: black;
  border-radius: 5px;
}
.top-multi-select-bar-ni {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  position: absolute;
  padding-top: 8px;
  padding-right: 10px;
  padding-left: 10px;
  left: 0;
  top: -33px;
  border-radius: 5px;
  /* background-color: #ae3ede; */
  background-color: black;
  border-radius: 5px;
}
.top-multi-select-bar-assignments {
  justify-content: space-between;
  width: fit-content;
  position: absolute;
  padding-top: 8px;
  padding-right: 10px;
  padding-left: 10px;
  left: 33px;
  top: -26px;
  border-radius: 5px;
  /*background-color: #ae3ede;*/
  background-color: black;
  border-radius: 5px;
}
.top-multi-select-bar-assignments {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  position: absolute;
  min-width: 68px;
  padding-top: 8px;
  padding-right: 19px;
  /* padding-left: 10px; */
  left: 422px;
  top: -26px;
  border-radius: 5px;
  /* background-color: #ae3ede; */
  background-color: inherit;
  border-radius: 5px;
}
.top-multi-select-bar-rank {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  position: absolute;
  min-width: 68px;
  padding-top: 8px;
  padding-right: 19px;
  /* padding-left: 10px; */
  left: 0;
  top: -33px;
  border-radius: 5px;
  /* background-color: #ae3ede; */
  background-color: inherit;
  border-radius: 5px;
}
.top-multi-select-bar-sms {
  justify-content: space-between;
  width: fit-content;
  position: absolute;
  padding-top: 8px;
  padding-right: 10px;
  padding-left: 10px;
  left: 316px;
  top: -33px;
  border-radius: 5px;
  /*background-color: #ae3ede;*/
  background-color: grey;
  border-radius: 5px;
}
.top-multi-select-bar-closedV {
  justify-content: space-between;
  width: fit-content;
  position: absolute;
  padding-top: 8px;
  padding-right: 10px;
  padding-left: 10px;
  right: 0;
  top: -33px;
  border-radius: 5px;
  background-color: inherit;
  min-width: 170px;
}
.top-multi-select-bar-countries {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  position: absolute;
  padding-top: 8px;
  padding-right: 10px;
  padding-left: 10px;
  left: 275px;
  top: -33px;
  border-radius: 5px;
  background-color: inherit;
  background-color: gray;
}

.loader-container {
  display: flex;
  align-items: center;
  margin-right: 0.2rem;
}

.top-check-div {
  display: inline-flex;
  z-index: 2;
}
.top-check-div > label{
  z-index: 2;
}


.multi-check-label {
  display: block;
  padding-left: 0.2rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
  position: relative;
  left: -78px;
}
.multi-check-label-questions-status {
  display: block;
  padding-left: 0.2rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
  position: relative;
  left: 0px;
}
.multi-check-label-advertising {
  display: block;
  padding-left: 0.2rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
  position: relative;
  left: 0px;
}
.multi-check-label-keyword {
  display: block;
  padding-left: 0.2rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
  position: relative;
  left: 0px;
}
.multi-check-label-device {
  display: block;
  padding-left: 0.2rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
  position: relative;
  left: 0px;
}
.multi-check-label-location {
  display: block;
  padding-left: 0.2rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
  position: relative;
  left: 0px;
}
.multi-check-label-placement {
  display: block;
  padding-left: 0.2rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
  position: relative;
  left: 0px;
}
.multi-check-label-assign {
  display: block;
  padding-left: 0.2rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
  position: relative;
  left: 0px;
}
.multi-check-label-sms {
  display: block;
  padding-left: 0.2rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
  position: relative;
  left: -84px;
}
.multi-check-label-questions {
  display: block;
  padding-left: 0.2rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
  position: relative;
  left: 0px;
}
.nav-tabs > li.active > a,
.nav-tabs > li.active > a:hover,
.nav-tabs > li.active > a:focus {
  color: #555;
  cursor: default;
  background-color: #1855e2;
  border: 1px solid #ddd;
  font-weight: 900;
  border-bottom-color: transparent;
}

form {
  width: 100%;
  box-sizing: border-box;
  background-color: white;
  box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.4);
  text-align: center;
  position: relative;
  border-radius: 2px;
}

form > div {
  color: white;
  padding-top: 24px;
  display: block;
  position: absolute;
  top: 0px;
  left: -1px;
  bottom: 0px;
  width: calc(33.33% + 5px);
  background-color: #fb9324;
  /* border-radius: 2px; */
  -webkit-box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.4);
  box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.4);
  z-index: 1;
  pointer-events: none;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
}

/*form::after {*/
/*  content:"";*/
/*  display:block;*/
/*  clear:both;*/
/*}*/

form label {
  float: left;
  width: calc(33.333% - 1px);
  position: relative;
  padding: 0px 0px 20px;
  overflow: hidden;
  border-left: solid 1px rgba(0, 0, 0, 0.2);
  transition: color 0.3s;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}

form label:first-child {
  border-left: none;
}

form label input {
  position: absolute;
  top: -200%;
}

form label div {
  z-index: 5;
  position: absolute;
  width: 100%;
}

form label.selected {
  color: white;
}
.for-three-opt-toggle {
  max-width: 68px;
  position: relative;
  top: -25px;
  right: -302px;
}
.font-and-wight {
  font-size: 11px;
  font-weight: bold;
  text-transform: uppercase;
  padding-top: 5px;
}
.for-top-search-for-non-sc {
  position: absolute;
  background: inherit;
  top: -40px;
  padding-top: 8px;
  min-height: 46px;
  border-radius: 5px;
  right: 0px;
  padding-right: 17px;
  padding-left: 6px;
}
.top-multi-select-bar-sms .input-main {
  right: -38px;
}
</style>
